import React, { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { dialogs, site } from '@yola/ws-sdk';
import { DifmUpsellDialog } from '@yola/webapp-plugins';
import { selectors, verifiers } from '@yola/subscription-manager-js';
import useFeatureFlags from 'yola-editor/src/js/modules/feature-flags/hooks/use-feature-flags';
import getPartnerData from 'yola-editor/src/js/modules/user/selectors/partner-data';
import getUserPreferences from 'yola-editor/src/js/modules/user/selectors/user-preferences';
import segment from 'src/js/modules/analytics/segment';
import dialogTypes from '../../dialogs/constants/dialog-types';

const {
  trackers: { trackEvent },
  constants: { events },
} = segment;

const DifmUpsellDialogContainer = () => {
  const partnerData = useSelector(getPartnerData, shallowEqual);
  const { currency } = useSelector(getUserPreferences);
  const { businessCategory } = useSelector(site.selectors.getSettings, shallowEqual);
  const activeHostingSubscription = useSelector(selectors.getActiveHostingSubscription);
  const hasPaidHostingSubscription =
    activeHostingSubscription?.type &&
    verifiers.hasPaidHostingPackageType([activeHostingSubscription.type]);

  const [featureFlags] = useFeatureFlags(['gold_reinforcement']);

  const { gold_reinforcement: isGoldReinforcementFeatureFlagEnabled } = featureFlags;

  const dispatch = useDispatch();

  const onClose = useCallback(() => {
    dispatch(dialogs.actions.hide());

    trackEvent(events.DIFM_UPSELL_CLOSE_CLICKED, {
      businessCategory: businessCategory || null,
    });
  }, [businessCategory, dispatch]);

  const onSubmit = useCallback(() => {
    trackEvent(events.DIFM_UPSELL_UPGRADE_CLICKED, {
      businessCategory: businessCategory || null,
    });

    dialogs.operations.show(dialogTypes.DIFM_ORDER_FORM_DIALOG);
  }, [businessCategory]);

  return (
    <DifmUpsellDialog
      partnerId={partnerData.id}
      term={activeHostingSubscription?.term}
      currency={currency}
      shouldReinforcePlanNames={isGoldReinforcementFeatureFlagEnabled}
      isUpgradeFlow={hasPaidHostingSubscription}
      onSubmit={onSubmit}
      onClose={onClose}
    />
  );
};

export default DifmUpsellDialogContainer;
